import * as React from 'react';
import { Link } from 'react-router';
import { __, __r } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { InfoText, InfoType } from '../General/InfoText';
import { SecondStep as SecondStepSummary } from './Summary/SecondStep';
import { FormInput } from '../Form/FormInput';
import { RequestProductTable } from './Items/RequestProductTable';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { ItemsProductTable } from './Items/ItemsProductTable';
import { FreeDelivery, zonePricesMap } from './FreeDelivery';
import { prop } from '../../../utilities';
import { FormTextArea } from '../Form/FormTextArea';

interface Props {
  theme: any;
  data: any;
  addToRequest: any;
  addToCart: any;
  isFetching: boolean;
  removeFromCart: any;
  changeCartItemNote: (gId: number, note: string) => void;
  changeCartNote: (note: string) => void;
  refreshCart: () => void;
  user: any;
  handleZoneInputChange: any;
  zoneId: number;
  hasPartlyOnStockItem: number;
  updateCart: (data: any) => void;
  cartB2BDiscount: number;
  freeDelivery: boolean;
}

function CartItemsPart({
  theme,
  data,
  addToRequest,
  addToCart,
  isFetching,
  removeFromCart,
  changeCartItemNote,
  changeCartNote,
  refreshCart,
  handleZoneInputChange,
  zoneId,
  hasPartlyOnStockItem,
  updateCart,
  cartB2BDiscount,
  user,
  freeDelivery,
}: Props) {
  const isB2B = user && user.b2b;
  let updateDataTimeout: any = null;
  const [requestsVisible, setRequestsVisible] = React.useState(true);
  const { items, user_id, cart_label, problems } = data;
  const [isUpdatingNote, setIsUpdatingNote] = React.useState(false);
  const [note, setNote] = React.useState(cart_label || '');
  const demands = items.filter(i => i.is_demand);
  const normalItems = items.filter(i => !i.is_demand);
  const hasNullPriceItems = items.some(i => i.sum_price === 0);
  const zip = (prop(data, 'delivery_address.zip')
    ? prop(data, 'delivery_address.zip')
    : prop(data, 'billing_address.zip')
    ? prop(data, 'billing_address.zip')
    : ''
  ).replace(/ /g, '');
  const prices = zoneId ? zonePricesMap[zoneId] : null;
  const spojFreePrice = prop(prices, 'spoj');
  const vykrFreePrice = prop(prices, 'vykr');
  const spojPrice = normalItems.reduce((price, item) => {
    return prop(item, 'product.root_category') === 1
      ? price + item.sum_price_without_vat
      : price;
  }, 0);
  const vykrPrice = normalItems.reduce((price, item) => {
    return prop(item, 'product.root_category') === 2
      ? price + item.sum_price_without_vat
      : price;
  }, 0);
  const spojPriceNeeded = spojFreePrice - spojPrice;
  const vykrPriceNeeded = vykrFreePrice - vykrPrice;
  const hasFreeDelivery =
    (spojFreePrice && spojFreePrice > 0) || (vykrFreePrice && vykrFreePrice > 0)
      ? (vykrFreePrice && vykrPriceNeeded <= 0) ||
        (spojFreePrice && spojPriceNeeded <= 0)
      : false;
  const priceNeeded = (spojPriceNeeded > vykrPriceNeeded && vykrFreePrice
    ? vykrPriceNeeded
    : spojPriceNeeded
  ).toFixed(2);
  const percentage =
    (+priceNeeded /
      (spojPriceNeeded > vykrPriceNeeded && vykrFreePrice
        ? vykrFreePrice
        : spojFreePrice)) *
    100;

  const handleNoteChange = e => {
    setNote(e.target.value);
  };

  const handleNoteBlur = () => {
    changeCartNote(note);
  };

  const requestsComponent = (
    <RequestProductTable
      products={demands}
      isFetching={false}
      removeFromCart={removeFromCart}
      addToRequest={addToRequest}
      changeCartItemNote={changeCartItemNote}
    />
  );

  const cartProblem = prop(
    problems.filter(p => p.type === 'cart')[0],
    'readable',
  );

  const handleFieldChange = (e: any) => {
    const value = e.target.value;
    const field = e.target.name;
    // dispatch({ field, value });
    // updateCart({ ...data, [field]: value });
    if (updateDataTimeout) {
      clearTimeout(updateDataTimeout);
    }

    updateDataTimeout = setTimeout(async () => {
      setIsUpdatingNote(true);
      updateCart({ ...data, [field]: value });
      setTimeout(() => {
        setIsUpdatingNote(false);
      }, 100);
    }, 200);
  };

  return (
    <Wrapper>
      {cartProblem && (
        <InfoText maxWidth={1168} type={InfoType.ERROR} info={cartProblem} />
      )}
      {!user && (
        <InfoText
          noIcon={true}
          type={InfoType.INFO}
          info={
            <>
              {__('Máte svoj účet?')}
              <LoginLink to={__r('routes:prihlasenie', 'prihlasenie')}>
                {__('Prihláste sa')}
              </LoginLink>
            </>
          }
        />
      )}

      {isB2B && freeDelivery ? (
        <InfoText type={InfoType.SUCCESS} info={__('Dopravu máte zadarmo')} />
      ) : isB2B ? (
        <FreeDelivery
          zoneId={zoneId}
          handleInputChange={handleZoneInputChange}
          zip={zip}
          hasFreeDelivery={hasFreeDelivery}
          priceNeeded={priceNeeded}
          percentage={percentage}
        />
      ) : null}

      {normalItems.length > 0 && (
        <ItemsProductTable
          products={normalItems}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          refreshCart={refreshCart}
          isB2B={isB2B}
        />
      )}

      {demands.length > 0 && (
        <>
          <RequestsWrapper>
            <TitleWrapper>
              <Title>{__('Dopytovať')}</Title>
              <SvgIcon
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => setRequestsVisible(!requestsVisible)}
                width={24}
                height={24}
                icon={IconType.downArrow}
                rotate={requestsVisible ? 180 : 0}
                alt={requestsVisible ? 'Skryť dopyty' : 'Zobraziť dopyty'}
                title={requestsVisible ? 'Skryť dopyty' : 'Zobraziť dopyty'}
                fill={theme.colors.textPrimary}
                cursor={'pointer'}
              />
            </TitleWrapper>
            {requestsVisible && requestsComponent}
          </RequestsWrapper>
          <DesktopWrapper>{requestsComponent}</DesktopWrapper>
        </>
      )}

      <OrderNrAndSummaryWrapper>
        <FormWrapper>
          <FormInput
            name={'requestnr'}
            type="text"
            label={'Číslo dopytu'}
            value={note}
            notRequired={true}
            marginBottom={56}
            marginRight={0}
            minWidthPx={288}
            onChange={handleNoteChange}
            onBlur={handleNoteBlur}
          />
          <FormTextArea
            name="note"
            type="text"
            label={__('Poznámka')}
            onChange={handleFieldChange}
            defaultValue={prop(data, 'note', '')}
          />
        </FormWrapper>
        <SecondStepSummary
          data={data}
          withoutBottomPart={true}
          isFetching={!isUpdatingNote && isFetching}
          isDemand={normalItems.length === 0}
          hasPartlyOnStockItem={hasPartlyOnStockItem}
          cartB2BDiscount={cartB2BDiscount}
          user={user}
        />
      </OrderNrAndSummaryWrapper>
      {hasPartlyOnStockItem ? (
        <InfoText
          type={InfoType.INFO}
          noIcon={true}
          info={__(
            'Cena produktov, ktoré nie sú skladom, nie je započítaná do hodnoty objednávky a ceny dopravy.',
          )}
        />
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  margin-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.m810`
      max-width: ${rem(400)};
      margin: 0 auto;
  `}
`;

const FormWrapper = styled(FlexCol)`
  width: 50%;

  ${({ theme }) => theme.mediab.m810`
     width: 100%;
  `}
`;

const TitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  padding-bottom: ${rem(32)};
  border-bottom: ${({ theme }) => theme.borders.primary};

  ${({ theme }) => theme.mediab.s450`
      margin: 0 -${rem(16)};
      padding: 0 ${rem(16)} ${rem(32)};
  `}
`;

const Title = styled.h3`
  font-size: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  line-height: ${rem(32)};
  font-weight: 400;
`;

const RequestsWrapper = styled(FlexCol)`
  display: none;

  ${({ theme }) => theme.mediab.m810`
    display: flex;
    margin-bottom: ${rem(24)};
  `}
`;

const DesktopWrapper = styled.div`
  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const LoginLink = styled(Link)`
  margin-left: ${rem(4)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;

const OrderNrAndSummaryWrapper = styled(FlexRow)`
  justify-content: space-between;
  flex-flow: row wrap;
  margin-top: ${rem(8)};

  ${({ theme }) => theme.mediab.m810`
      flex-flow: column;
      justify-content: center;
      align-items: center;
      max-width: ${rem(320)};
      width: 100%;
      margin: 0 auto;
  `}

  ${({ theme }) => theme.mediab.s450`
     max-width: initial;
     margin: initial;
  `}
`;

const WithTheme: any = withTheme(CartItemsPart);
export { WithTheme as CartItemsPart };
